import { createActionTypes } from '../redux/actionCreators';
import { keyBy } from 'lodash';

// TEAM Member Table type
export const SUPER_ADMIN = 'super_admin';

// MEMBER table view
export const MEMBER_TABLE_VIEWS = {
  UTILIZATION: 'utilization',
  ALL_MEMBERS: 'all_members',
  OVERVIEW: 'overview',
  ACTIVITY_LOG: 'activity_log',
  RECENT_LOGINS: 'recent_logins',
  SUPPRESSED_EMAILS: 'suppressed_emails',
};

export const DEFAULT_MEMBER_TABLE_VIEW = MEMBER_TABLE_VIEWS.ALL_MEMBERS;

export const MEMBER_TABLE_VIEWS_ARRAY = [
  {
    label: 'Members',
    value: MEMBER_TABLE_VIEWS.ALL_MEMBERS,
    hideSearchbar: false,
  },
  {
    label: 'Utilization',
    value: MEMBER_TABLE_VIEWS.UTILIZATION,
    hideSearchbar: true,
  },
  {
    label: 'Team Overviews',
    value: MEMBER_TABLE_VIEWS.OVERVIEW,
    hideSearchbar: true,
  },
  {
    label: 'Activity Log',
    value: MEMBER_TABLE_VIEWS.ACTIVITY_LOG,
    hideSearchbar: true,
  },
  {
    label: 'Recent Logins',
    value: MEMBER_TABLE_VIEWS.RECENT_LOGINS,
    hideSearchbar: true,
  },
  {
    label: 'Suppressed Emails',
    value: MEMBER_TABLE_VIEWS.SUPPRESSED_EMAILS,
    hideSearchbar: true,
  },
];

export const MEMBER_TABLE_VIEWS_HASH = keyBy(MEMBER_TABLE_VIEWS_ARRAY, 'value');

export const RESET_MEMBER_PASSWORD = createActionTypes('RESET_MEMBER_PASSWORD');

export enum TeamMemberColumns {
  Name = 'name',
  LastActive = 'last_active',
  AccountId = 'account_id',
  Email = 'email',
  Admin = 'is_admin',
  Active = 'is_active',
  FirstName = 'first_name',
  LastName = 'last_name',
  Role = 'role_name',
  ImpersonateButton = 'impersonateButton',
  CopyButton = 'copyButton',
  Checkbox = 'checkbox',
}
